<template>
  <base-card tabled>
    <template v-slot:header>
      <base-card-heading>
        Loan Security
      </base-card-heading>
      <base-button modal="#addSecurityModal" secondary small>
        Add Security
      </base-button>
    </template>
    <base-stats v-model="stats" />
    <securities-table v-model="securities" @remove="calculate" @updated="calculate" />
    <add-security-modal @saved="save" />
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

import AddSecurityModal from './AddSecurityModal.vue'
import SecuritiesTable from './SecuritiesTable.vue'

export default {
  created () {
    this.securities = this.$_.clone(this.project.securities)
    this.calculate()
  },

  data: () => ({
    securities: [],
    stats: []
  }),

  name: 'ProjectSecurities',

  components: {
    AddSecurityModal,
    SecuritiesTable
  },

  props: {
    facility: Object
  },

  computed: {
    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    calculate () {
      const hasFacility = this.$_.isPlainObject(this.project.facility)

      this.stats = [
        {
          stat: this.$formatting.toCurrency(this.getTotalSecurity()),
          text: 'Total Security'
        },
        {
          stat: hasFacility ? `${this.getCapitalLtv()}%` : 'n/a',
          text: 'Capital LTV'
        },
        {
          stat: hasFacility ? `${this.getTotalLtv()}%` : 'n/a',
          text: 'Total LTV'
        }
      ]
    },

    getCapitalLtv () {
      const facility = this.$_.get(this.project.facility, 'amount') || 0
      const security = this.getTotalSecurity()

      return new this.$big(security).div(facility).times(100).toFixed(2)
    },

    getTotalLtv () {
      const facility = this.$_.get(this.project.facility, 'amount') || 0
      const fees = this.facility.finalStatement.fees.toFixed(2)
      const interest = this.facility.finalStatement.interestAccrued.toFixed(2)
      const security = this.getTotalSecurity()

      return new this.$big(security)
        .plus(fees)
        .plus(interest)
        .div(facility)
        .times(100)
        .toFixed(2)
    },

    getTotalSecurity () {
      const amounts = []

      this.$_.map(this.securities, 'amount').forEach(amount => {
        amounts.push(this.$_.toNumber(amount))
      })

      return this.$_.sum(amounts)
    },

    async save (security) {
      this.securities.push(security)

      await this.$store.dispatch('core/projects/securities/add', security)

      this.calculate()
    }
  }
}
</script>
